/* Build Your Own CLEAR Kit v2 - guided builder.
   Money is integer cents throughout: add-ons priced at .99 drift in dollars. */
(function () {
  var CFG = (function () {
    var el = document.getElementById('byo-config');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  })();

  var COMP = CFG.components || {};
  var VAR = CFG.variants || {};
  var BOOKS = (CFG.books || []).filter(function (b) { return b && b.id; });

  // 2026-08-27 model. Every kit is professionally printed (Print at Home was
  // discontinued and its SKUs archived), and Expanded is TWO binders per adult:
  // Core Essentials (Sections 1-22) plus the Expanded binder (Sections 23-47).
  // Displayed prices MUST equal what the cart's real variants charge. Rebased
  // onto the bundles 2026-09-04 (see SECOND_ADULT_SAVING note below):
  //   Essentials  first adult $140 = orange $25 + printing & assembly $115
  //               each additional $140, matching the first (2026-09-08)
  //   Expanded    first adult $240 = Essentials $140 + green $25 + Exp svc $75
  //               each additional $251
  // Plus the Large case $50 and key organizer $9 - both of which a packaged
  // bundle includes - an equivalent build is 199 / 350 / 299 / 550, which is
  // the bundle price to the cent. Assembly,
  // personalization, Worksheet Library access and the Getting Started booklet
  // are free and deliberately have no entry here. The USB drive is a blank
  // add-on on the Extras step, priced live from the product like the books.
  var PRICE = {
    essentials: 14000,        // FIRST adult  - orange binder 2500 + svc 11500
    essentialsNext: 14000,    // each ADDITIONAL adult - same as the first, 2026-09-08
    expanded: 24000,          // FIRST adult  - Essentials 14000 + green 2500 + svc 7500
    expandedNext: 15000,      // each ADDITIONAL adult
    caseSmall: 3000,
    caseLarge: 5000,
    keyKit: 900               // each; most families need one
  };
  // The Large case holds a full household kit - the packaged Two Adult Expanded
  // ships four binders in ONE case.
  var LARGE_CASE_BINDERS = 4;
  // PRICING IS DERIVED FROM THE PACKAGED BUNDLES, which are the reference
  // (Adam, 2026-09-04: "bundle prices win", "we don't want people to pay more
  // for the same thing"). A bundle includes the Large case and the Key
  // Organizer System - both PDPs list them under What You Receive - so an
  // equivalent build is the kit plus caseLarge plus keyKit, and must land on
  // the bundle price exactly:
  //
  //   Essentials  1 adult   140 + 50 + 9 = 199      2 adults  140+151 +59 = 350
  //   Expanded    1 adult   240 + 50 + 9 = 299      2 adults  240+251 +59 = 550
  //
  // The additional adult costs MORE than the first (151 vs 140). That is forced
  // by the bundles and it is not a mistake: the household saving IS the shared
  // case and key organizer, charged once rather than twice. The old code
  // subtracted a further SECOND_ADULT_SAVING of $50 on top, and applied it to
  // the DISPLAYED price only - cartItems() pushed full-price variants - so a
  // 2-adult Essentials build read $180 and charged $230 at checkout. Found
  // 2026-09-04 by driving all four permutations through a real checkout. No
  // customer was hit: the constant arrived with the 08-27 rebuild and every
  // builder order since (#162291, #162294, #162295, #162305) was one adult.
  //
  // These numbers are the SERVICE VARIANT PRICES plus binders. Changing one
  // without the other reintroduces exactly that bug, so they move together.
  // The $0 parent product the cart transform merges a build's components into.
  // Used to recognise a previous build in the cart so adding a new one replaces it.
  var MAX_ADULTS = 2;
  // v4: the Worksheets (print at home) step was removed 2026-08-27 - every kit
  // is professionally printed - and Expanded became two binders per adult. Any
  // earlier saved state restores against the wrong step list and the wrong
  // binder maths, so the key moved and everyone starts from a blank build.
  // v7: the storage default became Large. restore() copies every saved key over
  // the defaults, so a build saved while the default was 'none' comes back with
  // no case selected and no way to tell it from a deliberate choice. Bumping the
  // key retires those builds instead of letting them quietly undo the default.
  var STORE_KEY = 'byo-clear-kit-v7';   // v7: Large storage case is the default

  // Adults and Kit Type were two screens asking two small questions, and the
  // count had to be priced off a kit the customer had not chosen yet. Merged
  // (Adam, 2026-08-27): pick the kit, then how many, on one screen, so the
  // quantity can show the real price instead of a "from".
  var STEPS = [
    { id: 'package', label: 'Your Kit' },
    { id: 'names',   label: 'Personalization' },
    { id: 'storage', label: 'Storage Case' },
    { id: 'addons',  label: 'Extras' },
    { id: 'review',  label: 'Review' }
  ];

  var ARROW = '<svg class="arw" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h9M9 4.5 12.5 8 9 11.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TICK = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7.4 5.6 11 12 3.4" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var state = {
    step: 0,
    adults: 1,
    // Preselected on purpose (Adam, 2026-08-27): the Kit Type step arrives with
    // Expanded checked and visibly recommended. pkgChosen still starts false, so
    // the summary stays blank until the customer actually engages with the step.
    pkg: 'expanded',
    names: [{ full: '' }],
    namesConfirmed: false,
    ht: true,          // always included, never a toggle
    caseType: 'large',   // most popular; a household kit fits one Large case
    caseQty: 1,
    keyKit: 0,
    workbook: true,   // always included, not configurable
    books: {},
    pkgChosen: false,  // no binder count or price until the kit type is picked
    // Furthest step the customer has advanced past. Every state field below has a
    // default, so without this the summary would announce the print format and
    // the free inclusions before those steps are ever seen.
    maxStep: 0
  };

  // ---------- helpers ----------
  var $ = function (id) { return document.getElementById(id); };

  function money(cents) {
    var whole = cents % 100 === 0;
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shortTitle(t) { return String(t).split(':')[0].trim(); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  // A photo chosen in the theme editor for this builder wins over the product's
  // own featured image, so the Kit Type cards can use a shot picked for them
  // without changing what the product page shows.
  function img(key) {
    var over = (CFG.imageOverrides || {})[key];
    return over || (COMP[key] && COMP[key].image) || '';
  }

  function save() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function restore() {
    try {
      // ?reset=1 starts a clean build. The "Start over" button was removed on
      // purpose - it invited abandonment - but with nothing else to clear saved
      // state, testing a change meant hand-editing localStorage. No customer
      // encounters this unless they type it.
      if (/[?&]reset=1\b/.test(location.search)) {
        localStorage.removeItem(STORE_KEY);
        return;
      }
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      if (s && typeof s === 'object') {
        Object.keys(state).forEach(function (k) { if (k in s) state[k] = s[k]; });
        // keyKit used to be a checkbox. A saved `true` becomes a quantity of 1
        // so a returning customer's saved order still prices correctly.
        if (typeof state.keyKit === 'boolean') state.keyKit = state.keyKit ? 1 : 0;
        state.keyKit = Math.max(0, Math.trunc(state.keyKit) || 0);
        // The step now offers one or two adults only; a state saved when 3-10
        // were selectable must not restore into a choice that no longer exists.
        state.adults = Math.min(MAX_ADULTS, Math.max(1, Math.trunc(state.adults) || 1));
        // Sessions saved before maxStep existed have no value for it. Without
        // this they restore mid-build with the whole progress nav locked shut.
        state.maxStep = Math.max(state.maxStep || 0, state.step || 0);
        syncNames();
      }
    } catch (e) {}
  }
  function syncNames() {
    while (state.names.length < state.adults) state.names.push({ full: '' });
    state.names.length = state.adults;
  }

  // ---------- pricing ----------
  function isExpanded() { return state.pkg === 'expanded'; }
  // Single source of truth for which case the order actually gets. The customer
  // picks freely - no case and small case are real choices for everyone.
  function effectiveCaseType() { return state.caseType; }

  // All-in per adult; printing, assembly and personalization are included.
  // NOT a flat rate x adults - the first adult and each additional adult carry
  // their own price, so that a build lands on the bundle price exactly.
  function firstAdultPrice() { return isExpanded() ? PRICE.expanded : PRICE.essentials; }
  function nextAdultPrice()  { return isExpanded() ? PRICE.expandedNext : PRICE.essentialsNext; }
  function bindersCostFor(adults) {
    return firstAdultPrice() + nextAdultPrice() * Math.max(0, adults - 1);
  }
  // Kept for the Learn more popups, which quote a single adult.
  function unit() {
    return {
      essentials: PRICE.essentials,
      expandedAdd: PRICE.expanded - PRICE.essentials
    };
  }

  // True once the customer is on, or past, the step that owns the storage case.
  function caseSettled() { return decided('storage') || onStep('storage'); }

  function compute() {
    var binders = state.adults * (state.pkg === 'expanded' ? 2 : 1);
    var ct = caseSettled() ? effectiveCaseType() : 'none';
    var caseUnit = ct === 'small' ? PRICE.caseSmall : ct === 'large' ? PRICE.caseLarge : 0;
    // Derived, not asked. A Deluxe case holds a household kit (four binders), so the number needed
    // follows from the binder count - there is nothing for the customer to decide
    // and a stepper only invited them to get it wrong.
    //
    // Large cases follow binder capacity, not adult count: a Large case holds
    // three binders, so two Essentials binders share one case and ship in one
    // box. That is what the packaged Two Adult Essentials kit is, and pricing
    // the builder per-adult made the same kit cost $50 more here than on the
    // product page. Two Adult Expanded is six binders, so it still takes two.
    //
    // Compact is a documents-only case that does not hold binders at all. It is
    // one per order, not one per adult (Adam, 2026-08-27): a household shares it,
    // the same way they share a Large case.
    var caseQty = ct === 'none' ? 0
      : ct === 'large' ? Math.max(1, Math.ceil(binders / LARGE_CASE_BINDERS))
      : 1;
    var caseCost = caseUnit * caseQty;
    var booksCost = BOOKS.reduce(function (n, b) { return n + (state.books[b.id] || 0) * b.price; }, 0);

    var bindersCost = bindersCostFor(state.adults);

    return {
      perAdult: Math.round(bindersCost / state.adults),
      binders: binders,
      bindersCost: bindersCost,
      caseQty: caseQty,
      caseCost: caseCost,
      booksCost: booksCost,
      recommendedLarge: Math.ceil(binders / LARGE_CASE_BINDERS),
      total: bindersCost
           + caseCost
           + PRICE.keyKit * (state.keyKit || 0)
           + booksCost
    };
  }


  // The kit line covers the kit itself and what goes inside it. Add-ons chosen on
  // the Extras step - books and the Key Storage System - are listed separately
  // under "Also in your order", so their cost comes out of this figure.
  function keysCost() { return PRICE.keyKit * (state.keyKit || 0); }
  function kitTotal() {
    var c = compute();
    return c.total - c.booksCost - keysCost();
  }

  function stepIndex(id) {
    for (var i = 0; i < STEPS.length; i++) if (STEPS[i].id === id) return i;
    return -1;
  }
  // True once the customer has advanced PAST the step that owns this choice, so
  // the summary never reports a default they have not been shown yet.
  function decided(id) { return state.maxStep > stepIndex(id); }
  function onStep(id) { var s = STEPS[state.step]; return !!s && s.id === id; }

  // The detail that sits under the single CLEAR Kit line. Builds up as the
  // customer moves through the steps rather than showing every default at once.
  function kitDetail() {
    var c = compute();
    var d = [];

    // The kit name is already the summary line label, so it is not repeated here.
    // Every kit is professionally printed, so that is stated once rather than
    // repeated as a per-build decision.
    if (decided('package')) d.push('Professionally printed and assembled');
    // Adults and binders are not repeated here - the meta line directly above
    // this list already reads "1 adult - 2 binders".

    if (decided('names')) {
      for (var i = 0; i < state.adults; i++) {
        var who = (!skipped(i) && nameOf(i)) ? esc(nameOf(i)) : 'No personalization';
        d.push('Kit ' + (i + 1) + ': ' + who);
      }
    }

    if (caseSettled() && effectiveCaseType() !== 'none') {
      d.push(c.caseQty + ' &times; ' + (effectiveCaseType() === 'small' ? 'Compact storage case' : 'Large storage case'));
    }
    // Key Storage is an Extras-step add-on, so it is listed under "Also in your
    // order" with its own price rather than buried in the kit's bullet list.

    // Free inclusions used to be abbreviated here AND spelled out on the Extras
    // step. They now live in one place - their own summary group below.
    return d;
  }

  // Binder count only means something once a kit type is settled, which now
  // happens on the same step as the count.
  // Empty once a kit is chosen: the kit line directly below now reads
  // "Expanded for 2 people", which said the same thing twice over.
  function metaText() {
    return state.pkgChosen ? '' : plural(state.adults, 'kit', 'kits');
  }

  function chosenBooks() {
    return BOOKS.filter(function (b) { return (state.books[b.id] || 0) > 0; });
  }

  // One field: what they type is what gets printed, so middle initials,
  // suffixes and punctuation ("Michael J. Bennett Jr.") need no special
  // handling. The fallback reads an older saved build that still had the
  // three-part shape.
  function nameOf(i) {
    var n = state.names[i] || {};
    if (n.full != null && String(n.full).trim()) return String(n.full).trim().replace(/\s+/g, ' ');
    return [n.first, n.middle, n.last]
      .map(function (s) { return String(s == null ? '' : s).trim(); })
      .filter(Boolean).join(' ').replace(/\s+/g, ' ');
  }
  function skipped(i) { return !!(state.names[i] && state.names[i].skip); }
  function anyPersonalized() {
    for (var i = 0; i < state.adults; i++) if (!skipped(i)) return true;
    return false;
  }
  // Messages talk about the customer's actual order: two adults get two kits.
  function kitWord() { return state.adults > 1 ? 'CLEAR Kits' : 'CLEAR Kit'; }
  // Small counts read better spelled out in a sentence than as digits.
  var NUM_WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
  function numWord(n) { return NUM_WORDS[n] || String(n); }
  function allNamesFilled() {
    for (var i = 0; i < state.adults; i++) {
      if (skipped(i)) continue;
      if (!nameOf(i)) return false;
    }
    return true;
  }

  // ---------- cart ----------
  function cartItems() {
    var c = compute();
    var items = [];

    // ONE parent line for the whole build, priced, exactly like a packaged kit.
    // The cart transform expands it into the real stocked SKUs behind the scenes
    // at 0.00 each, so inventory still moves and HQ still reads what to build,
    // while the customer sees one line and one price.
    //
    // This replaced pushing the components directly. Under the old model the
    // components carried the money, and a merged bundle's price IS the sum of
    // its components, so Shopify printed every one of them on the order and the
    // confirmation - #162313 showed the customer "CLEAR Kit printing & assembly
    // (first adult) $115.00". Adam, 2026-09-04: "no assembly line items shown.
    // no individual price points."
    //
    // The parent variant's price MUST equal what the components used to sum to.
    // Nothing in Shopify enforces that, and it is the same drift that made the
    // builder display $180 and charge $230 earlier today, so the four prices are
    // asserted against PRICE in test-builder.js rather than trusted.
    var kitWord = state.pkg === 'expanded' ? 'Expanded' : 'Essentials';
    var buildId = 'K' + Date.now().toString(36).toUpperCase().slice(-6);
    // THE CASE IS PART OF THE KIT, not a line beside it (Adam, 2026-09-04:
    // "still showing the storage case as an extra"). A packaged kit includes its
    // case in one price and never lists it separately, so a configured kit does
    // the same: twelve variants, kit x adults x case, each priced with the case
    // already in it. The key organizer and the books stay their own lines,
    // because they genuinely are add-ons rather than part of the kit.
    // caseWord FIRST: parentKey reads it. When these were the other way round,
    // var hoisting made caseWord undefined at that point, caseSuffix fell to
    // 'NONE', and every build silently bought the no-case variant - a customer
    // paying for a Large case would have been charged $491 instead of $541 and
    // received no case. Caught on a live cart before it took an order.
    var caseWord = caseSettled()
      ? (effectiveCaseType() === 'small' ? 'Compact'
        : effectiveCaseType() === 'large' ? 'Large'
        : 'None')
      : 'None';

    var caseSuffix = caseWord === 'Compact' ? 'SM' : caseWord === 'Large' ? 'LG' : 'NONE';
    var parentKey = (isExpanded() ? 'kitExp' : 'kitEss') + (state.adults > 1 ? '2A' : '1A') + caseSuffix;

    // THE KIT LINE DESCRIBES THE KIT, AND NOTHING THAT BILLS SEPARATELY.
    // The key organizer, the storage case and the books are their own line
    // items, priced, sitting directly above and below this one - so listing
    // them here printed each of them twice on the same order (Adam, 2026-09-04:
    // "why is there a second item for the case?").
    //
    // Heirloom & Tell is the exception, and the reason this property still
    // exists: it is an entitlement, not a line item, so nothing else on the
    // order says the customer gets it. HQ's Heirloom & Tell test reads this
    // value and matches /heirloom/i on it.
    var addons = [];
    if (state.ht) addons.push('Heirloom & Tell, Details in the CLEAR Kit Resource Center');

    var props = { _biw_build: buildId };
    // Visible, and named the way a packaged kit names them, so an order reads
    // the same whichever way it was bought. The transform copies these onto each
    // expanded component, which is where HQ picks them up.
    for (var i = 0; i < state.adults; i++) {
      var who = (!skipped(i) && nameOf(i)) ? nameOf(i) : 'Not personalized';
      props['Adult ' + (i + 1) + ' Full Name'] = who;
    }
    // Just the kit name (Adam, 2026-09-04). The section count and "professionally
    // printed" were true but redundant: the variant beside it already reads
    // "Expanded, Two Adults", and every kit is professionally printed since the
    // 08-27 model, so neither told the customer anything they had chosen.
    props['Kit'] = kitWord;
    props['Binders'] = state.pkg === 'expanded' ? 'Orange, Green' : 'Orange';
    // Only when there ISN'T one. A purchased case is its own line item and says
    // so itself; repeating it here is the duplication above. "None" carries real
    // information though - it is the difference between a kit that ships without
    // a case and one where somebody forgot to pack it, which is exactly the
    // #162305 confusion, so it is still stated.
    if (caseWord === 'None') props['Storage case'] = 'None';
    if (addons.length) props['Also included'] = addons.join(' · ');
    // _biw_cfg_case and _biw_cfg_addons are NOT sent any more (Adam, 2026-09-04:
    // "we don't need case and h&t twice"). They duplicated "Storage case" and
    // "Also included" word for word, and the Shopify order page renders both,
    // so the same sentence appeared twice on every order.
    //
    // HQ's Heirloom & Tell test used to key on _biw_cfg_addons. It was taught to
    // read "Also included" FIRST, in a separate deploy, because dropping the
    // hidden key before that would have stopped granting the free year with no
    // error at all - exactly how _biw_cfg_kit disappearing put an Essentials
    // cover on an Expanded kit and went unnoticed for weeks.

    items.push({ id: VAR[parentKey], quantity: 1, properties: props });

    // No case line item. The chosen variant above already carries it, and its
    // price. Adding one here is what printed the case twice on #162325.

    var stamp = { _biw_build: buildId };
    if (state.keyKit) items.push({ id: VAR.keyKit, quantity: state.keyKit, properties: stamp });

    BOOKS.forEach(function (b) {
      var q = state.books[b.id] || 0;
      if (q > 0) items.push({ id: b.id, quantity: q, properties: stamp });
    });

    return items.filter(function (it) { return it.id; });
  }

  // What the preview panel and summary describe.
  function lineItems() {
    var c = compute();
    var items = [];

    // Two rows when there are two adults: the first adult and each additional
    // adult are priced differently, so one row x qty would misstate the total.
    var kitName = isExpanded() ? 'CLEAR Kit Expanded, printed and assembled'
                               : 'CLEAR Kit Essentials, printed and assembled';
    items.push({ name: kitName + ' (first adult)', qty: 1, each: firstAdultPrice() });
    if (state.adults > 1) {
      items.push({ name: kitName + ' (additional adult)', qty: state.adults - 1, each: nextAdultPrice() });
    }

    if (state.workbook) items.push({ name: 'Estate & End-of-Life Summary Workbook', qty: 1, each: 0 });
    items.push({ name: 'CLEAR Kit Worksheet Library access', qty: 1, each: 0 });
    if (effectiveCaseType() === 'small') items.push({ name: 'Compact storage case', qty: c.caseQty, each: PRICE.caseSmall });
    if (effectiveCaseType() === 'large') items.push({ name: 'Large Binder Case', qty: c.caseQty, each: PRICE.caseLarge });
    if (state.keyKit) items.push({ name: 'Key Storage System', qty: state.keyKit, each: PRICE.keyKit });
    BOOKS.forEach(function (b) {
      var q = state.books[b.id] || 0;
      if (q > 0) items.push({ name: b.title, qty: q, each: b.price });
    });
    if (state.ht) items.push({ name: 'Heirloom & Tell limited access, 1 year', qty: state.adults, each: 0 });
    items.push({ name: 'Getting Started Packet', qty: 1, each: 0 });
    items.push({ name: 'Three Notification Cards', qty: 1, each: 0 });
    return items;
  }

  // ---------- learn more ----------
  // The real CLEAR Kit section list. Binder 1 (Core Essentials) is Sections
  // 1-22; the Expanded binder carries Sections 23-47 in one binder.
  var BINDER1 = [
    'Estate &amp; End-of-Life Summary Report', 'Important Contacts', 'Identity &amp; Citizenship',
    'Last Will &amp; Testament', 'Trusts',
    'Advance Directive, Medical Power of Attorney, &amp; Living Will', 'HIPAA Authorization',
    'Financial Power of Attorney', 'Organ, Tissue &amp; Body Donation', 'Private Medical Insurance',
    'Medicare &amp; Medicaid', 'Life, Disability &amp; Long-Term Care Insurance',
    'Social Security &amp; Government Benefits', 'Digital Legacy Plan',
    'Account Access &amp; Authentication', 'Email &amp; Online Accounts', 'Devices &amp; Phone Plans',
    'Income', 'Financial Accounts', 'Credit Cards', 'Expenses &amp; Recurring Payments',
    'Final Resting Place Instructions'
  ];
  var BINDER2 = [
    'Family Information &amp; History', 'Spouse, Partner, &amp; Household Information',
    'Children, Dependents, &amp; Others Who Rely on Me', 'Pets',
    'Faith, Spirituality, &amp; Tradition', 'Military Service &amp; Benefits',
    'Memberships, Organizations, &amp; Affiliations', 'Medical Summary', 'Medical Providers',
    'Career &amp; Education', 'Residence History',
    'Ethical Will, Good to Know, &amp; Legacy Messages', 'DNR, POLST &amp; MOLST',
    'Residences &amp; Real Property', 'Vehicles, Boats &amp; Recreational Property',
    'Belongings, Valuables &amp; Heirlooms', 'Firearms &amp; Regulated Items',
    'Storage Units &amp; Safe Deposit Boxes', 'Privately Stored Property',
    'Employer &amp; Contractual Benefits', 'Debts Owed to You', 'Debts You Owe',
    'Business Interests', 'Non-Medical Insurance', 'Tax Returns &amp; Tax Information'
  ];
  var TOTAL_SECTIONS = BINDER1.length + BINDER2.length;

  // Card previews: real section names, six visible, rest behind Learn more.
  // The Kit Type cards deliberately carry no section bullets. Step 2 asks one
  // question - how much do you want to organize - and the full section lists
  // live behind Learn more for anyone who wants them.

  function sectionList(items, startAt) {
    return '<ul class="secs" style="list-style:none;padding-left:0">' +
      items.map(function (s) { return '<li>' + s + '</li>'; }).join('') + '</ul>';
  }

  var LEARN = {
    chooseKit: {
      title: 'Which one is right for you?',
      body: function () {
        var u = unit();
        return '<p>Both start with the same Core Essentials binder, covering the essential sections' +
          '. The difference is how much of the rest of your life you want written down.</p>' +
          '<h3>Expanded, ' + money(u.essentials + u.expandedAdd) + ' per adult</h3>' +
          '<p>Two binders covering every section, adding property, ' +
          'money, household, family, medical and care. The complete system, and worth it if you ' +
          'have a business, rental property, or people who depend on you.</p>' +
          '<h3>Essentials, ' + money(u.essentials) + ' per adult</h3>' +
          '<p>The information your family is most likely to need first, in one binder.</p>' +
          '<p><strong>You are not locked in.</strong> The Expanded binder can be added for any ' +
          'adult later at the same ' + money(u.expandedAdd) + ', so starting with Essentials ' +
          'costs you nothing but the wait.</p>';
      }
    },
    perAdult: {
      title: 'Why does each adult need their own kit?',
      image: function () { return img('essentials'); },
      body: function () {
        return '<p>Many CLEAR Kit sections are specific to one person, including wills, medical ' +
          'wishes, accounts, benefits, providers, and instructions.</p>' +
          '<p>Giving each adult their own labeled binders keeps their information separate, ' +
          'complete, and easier for loved ones to use. Shared information, such as details about ' +
          'your home, only needs to be entered once.</p>';
      }
    },
    essentials: {
      title: 'Essentials',
      image: function () { return img('essentials'); },
      price: function () { return unit().essentials; },
      body: function () {
        return '<p>A single binder per adult. The Core Essentials binder covers the essential sections' +
          ': the information your family is most likely to need first.</p>' +
          '<h3>Core Essentials</h3>' + sectionList(BINDER1, 1) +
          '<p>Each guided tab explains what belongs in the section, what to collect, why it matters, and how your executor may use it.</p>';
      }
    },
    expanded: {
      title: 'Expanded',
      image: function () { return img('expanded'); },
      price: function () { return unit().essentials + unit().expandedAdd; },
      body: function () {
        var u = unit();
        return '<p>Two binders per adult, covering every CLEAR Kit section.</p>' +
          '<div class="cmp-wrap"><table class="cmp"><thead><tr><th></th><th>Essentials</th><th>Expanded</th></tr></thead><tbody>' +
            '<tr><td>Binders</td><td>1</td><td>2</td></tr>' +
            '<tr><td>Sections</td><td>The essential sections</td><td>Every section</td></tr>' +
            '<tr><td>Per adult</td><td>' + money(u.essentials) + '</td><td>' + money(u.essentials + u.expandedAdd) + '</td></tr>' +
          '</tbody></table></div>' +
          '<h3>Core Essentials</h3>' + sectionList(BINDER1, 1) +
          '<h3>Expanded: personal, family, property &amp; money</h3>' + sectionList(BINDER2, BINDER1.length + 1);
      }
    },
    htAccess: {
      title: 'Heirloom & Tell',
      image: function () { return img('htAccess'); },
      body: function () {
        return '<p>Heirloom &amp; Tell is Buried in Work&rsquo;s online platform for preserving ' +
          'family stories, organizing important information, documenting belongings and wishes, ' +
          'and helping the people you trust know what matters and what to do next.</p>' +
          '<ul>' +
            '<li>One free year of limited access for each adult included in your order</li>' +
            '<li>No charge and no credit card required</li>' +
            '<li>Upgrade or continue after the first year only if you choose</li>' +
            '<li>Activate it when you are ready, or not at all</li>' +
          '</ul>' +
          '<p>Your CLEAR Kit works independently, with or without Heirloom &amp; Tell.</p>';
      }
    },
    caseSmall: {
      title: 'Compact storage case',
      image: function () { return img('caseSmall'); },
      price: function () { return PRICE.caseSmall; },
      body: function () { return COMP.caseSmall && COMP.caseSmall.body; }
    },
    caseLarge: {
      title: 'Large storage case',
      image: function () { return img('caseLarge'); },
      price: function () { return PRICE.caseLarge; },
      body: function () { return COMP.caseLarge && COMP.caseLarge.body; }
    },
    keyKit: {
      title: 'Key Storage Kit',
      image: function () { return img('keyKit'); },
      price: function () { return PRICE.keyKit; },
      body: function () { return COMP.keyKit && COMP.keyKit.body; }
    },
    workbook: {
      title: 'Estate & End-of-Life Summary Workbook',
      image: function () { return img('workbook'); },
      price: function () { return 0; },
      body: function () {
        return '<p>The high-level summary your family is most likely to reach for first.</p>' +
          '<p>When something happens, the people helping you rarely start by reading three ' +
          'binders. They need a short answer to a handful of urgent questions: who to call, ' +
          'where the important documents are, what accounts exist, and what you wanted.</p>' +
          '<p>The Summary Workbook is that short answer. It sits at the front of your CLEAR Kit ' +
          'and points to everything else.</p>' +
          '<p>You receive it by email after ordering, so you can begin filling it in before your ' +
          'binders arrive.</p>';
      }
    },
    gettingStarted: {
      title: 'Getting Started Packet',
      image: function () { return img('gettingStarted'); },
      price: function () { return 0; },
      // Written here rather than pulled from the product description: the packet
      // is an internal component, so its product copy is not customer-facing.
      body: function () {
        return '<p>Sometimes, knowing where to begin is the hardest part. This packet explains ' +
          'what is included in your CLEAR Kit, how everything is organized, and what to do next, ' +
          'whether you are opening it yourself or a family member finds it later.</p>';
      }
    },
    notificationCards: {
      title: 'Three Notification Cards',
      image: function () { return img('notificationCards'); },
      price: function () { return 0; },
      body: function () { return COMP.notificationCards && COMP.notificationCards.body; }
    },
    // One popup covering all four free inclusions. The summary panel lists the
    // titles only - four one-line descriptions cost more height than they earned.
    included: {
      title: 'Included in every kit, at no cost',
      price: function () { return 0; },
      body: function () {
        return '<p><strong>CLEAR Kit Worksheet Library access</strong><br>' +
          'Online access to every worksheet in your kit, as print optimized PDFs and ' +
          'interactive PDFs you can type into and save. Your access code is printed on the ' +
          'cover sheet inside your binder, and you can print replacement pages whenever ' +
          'you need them.</p>' +
          '<p><strong>One free year of limited access to Heirloom &amp; Tell</strong><br>' +
          'Our online platform for preserving family stories and organizing important ' +
          'information. ' + (state.adults > 1 ? 'One year for each adult in your order. ' : '') +
          'You do not have to use it, and we will email activation instructions after ' +
          'your order.</p>' +
          '<p><strong>Estate &amp; End-of-Life Summary Workbook</strong><br>' +
          'The high-level summary your family is most likely to reach for first. It sits at ' +
          'the front of your CLEAR Kit and points to everything else. You receive it by ' +
          'email after ordering, so you can start before your binders arrive.</p>' +
          '<p><strong>Getting Started Packet</strong><br>' +
          'Tells you what to do first - what is included, how it is organized, and what ' +
          'comes next, whether you are opening it yourself or a family member finds it later.</p>' +
          '<p><strong>Three Notification Cards</strong><br>' +
          'For the people who should know where your kit is kept. Give them out so the ' +
          'right people can find it when it matters.</p>';
      }
    }
  };

  function openLearn(key) {
    var l = LEARN[key];
    if (!l) return;
    // Learn-more panels are explanatory copy, not merchandising. No imagery.
    // Book panels still pass their cover through showDetail directly.
    var price = typeof l.price === 'function' ? l.price() : null;
    showDetail(l.title, l.body(), '', price);
  }

  // No imagery in any panel. These are explanations read while deciding, and a
  // large product shot pushed the words that answer the question off-screen.
  // The `image` argument is retained so callers do not need changing.
  function showDetail(title, bodyHtml, image, price) {
    $('detail-title').textContent = title;
    $('detail-body').innerHTML = bodyHtml || '';
    var media = $('detail-media');
    media.innerHTML = '';
    media.hidden = true;
    var p = $('detail-price');
    if (typeof price === 'number') {
      p.textContent = price === 0 ? 'Included at no cost' : money(price);
      p.hidden = false;
    } else { p.hidden = true; }
    $('detail').classList.add('open');
    // Open at the top. Close sits at the end of the content, so focusing it
    // without preventScroll dragged every panel straight to the bottom.
    var card = $('detail').querySelector('.payload-card');
    if (card) card.scrollTop = 0;
    $('detail').scrollTop = 0;
    $('detail-close').focus({ preventScroll: true });
  }

  // ---------- step rendering ----------
  function learnBtn(key, label) {
    return '<button type="button" class="learn" data-learn="' + key + '">' + (label || 'Learn more') + '</button>';
  }

  function optCard(opts) {
    return '<label class="opt' + (opts.disabled ? ' na' : '') + '">' +
      '<input type="radio" name="' + opts.group + '" value="' + opts.value + '"' +
      (opts.on ? ' checked' : '') + (opts.disabled ? ' disabled' : '') +
      ' data-set="' + opts.group + '">' +
      // Row layout, matching the Extras step: small square thumbnail, a copy
      // column, price on the right. The old card - 16/9 image on top, then a
      // stack - ran 250-340px per option, so two options filled a laptop screen
      // on their own. The row is about a third of that and reads the same.
      '<span class="opt-body">' +
        (opts.image ? '<span class="opt-media"><img src="' + opts.image + '" alt="" loading="lazy"></span>'
                    : (opts.spacer ? '<span class="opt-media opt-media--empty" aria-hidden="true"></span>' : '')) +
        '<span class="opt-copy">' +
          '<span class="opt-top">' +
            '<span class="opt-name"><span class="opt-tick">' + TICK + '</span>' + opts.name + '</span>' +
            (opts.badge ? '<span class="badge-pop">' + opts.badge + '</span>' : '') +
          '</span>' +
          (opts.sub ? '<span class="opt-sub">' + opts.sub + '</span>' : '') +
          (opts.desc ? '<span class="opt-desc">' + opts.desc + '</span>' : '') +
          (opts.feat ? '<ul class="feat">' + opts.feat.map(function (f) { return '<li>' + f + '</li>'; }).join('') + '</ul>' : '') +
          (opts.learn ? learnBtn(opts.learn) : '') +
        '</span>' +
        (opts.price ? '<span class="opt-price">' + opts.price + '</span>' : '') +
      '</span>' +
    '</label>';
  }

  var RENDER = {};

  // Some people do not want to answer questions. Give them the door - one per
  // kit, Expanded first, so nobody is funneled to the cheapest option only.
  function kitsEscape() {
    var kits = (CFG.kits || []).filter(function (k) { return k && k.url; });
    if (!kits.length) return '';
    // Essentials first (Adam, 2026-08-27), matching the Kit Type step: the
    // cheaper starting point is the one people should read first.
    kits = kits.slice().sort(function (a, b) { return a.price - b.price; });
    return '<div class="escape">' +
      '<div class="escape-copy"><strong>Prefer not to configure?</strong>' +
        '<p>Our ready-made kits are the same price, already put together for you.</p></div>' +
      '<span class="escape-ctas">' +
      kits.map(function (k) {
        var label = esc(shortTitle(k.title).replace(/CLEAR Kit\s*/i, '').replace(/\s*Bundle/i, ''));
        return '<a class="escape-cta" href="' + k.url + '">' + label + ' &middot; ' + money(k.price) + '</a>';
      }).join('') + '</span>' +
    '</div>';
  }

  // One or two adults only (Adam, 2026-08-27: "nobody is ordering for 5 people").
  // Three-plus goes to a quote conversation instead of a wizard nobody uses.
  // The whole build for the adults chosen, not a per-adult figure multiplied.
  // Multiplying was safe only while every adult cost the same; under
  // bundle-matched pricing the additional adult has its own price.
  function kitPrice(pkg) {
    var expanded = pkg === 'expanded';
    var first = expanded ? PRICE.expanded : PRICE.essentials;
    var next  = expanded ? PRICE.expandedNext : PRICE.essentialsNext;
    return money(first + next * Math.max(0, state.adults - 1));
  }

  RENDER.package = function () {
    var u = unit();

    // Essentials leads: the cheaper starting point is the one people read first.
    var cards = '<div class="cards two">' +
      optCard({
        group: 'pkg', value: 'essentials', on: state.pkg === 'essentials',
        image: img('essentials'), name: 'Essentials',
        price: kitPrice('essentials'),
        sub: '1 binder &middot; The essential sections',
        desc: 'What your family would need first. Add the Expanded binder later at the same price.',
        learn: 'essentials'
      }) +
      optCard({
        group: 'pkg', value: 'expanded', on: state.pkg === 'expanded',
        image: img('expanded'), name: 'Expanded', badge: 'Most popular',
        price: kitPrice('expanded'),
        sub: '2 binders &middot; Every section',
        desc: 'The complete system in just two binders per adult.',
        learn: 'expanded'
      }) +
    '</div>';

    // Priced for the kit they just chose, on the same screen, so there is no
    // "from" and no gap between the number and what it costs.
    var btns = [1, 2].map(function (v) {
      // BEST VALUE, on the button it applies to, so it is read at the moment of
      // choosing (Adam, 2026-09-04).
      //
      // The claim is a fact, not a rounded-up one: two kits cost $149 less than
      // two single kits on BOTH tiers - Essentials 249 against 398, Expanded 449
      // against 598. Derived here rather than typed, so it cannot go stale the
      // way "Save $50" did: that badge was hardcoded, was really $48, and by the
      // afternoon was $149 while still saying $50. If the prices move, this
      // moves with them.
      // BEST VALUE, and deliberately WITHOUT a figure (Adam, 2026-09-04).
      //
      // The saving is real but conditional, and this badge is shown BEFORE the
      // storage case is chosen, so no single number is true when it renders:
      //   kit only, no case      $90   (140 x2 = 280  vs 190)
      //   with a Large case     $140   (190 x2 = 380  vs 240)
      //   with case and key     $149   (199 x2 = 398  vs 249)
      // The difference is the shared case and key organizer, which a household
      // buys once instead of twice.
      //
      // A number here is how "Save $50" went wrong twice in one day: hardcoded,
      // actually $48, and by the afternoon $149 while still reading $50. The
      // label alone is true whenever it is shown, and cannot go stale.
      var save = v === 2 ? '<span class="adult-save">Best value</span>' : '';
      // No price here: the kit cards below carry it, and for two kits they show
      // the saving as was/now. Repeating a figure that depends on a choice made
      // underneath just gave the same number two homes.
      return '<button type="button" class="adult-btn' + (state.adults === v ? ' on' : '') + '" data-adults="' + v + '">' +
        save +
        '<span class="adult-n">' + v + '</span>' +
        '<span class="adult-w">' + (v === 1 ? 'Kit' : 'Kits') + '</span></button>';
    }).join('');

    return '<h2>Choose your CLEAR Kit</h2>' +
      // Quantity first: it is the smaller question, it sets the numbers on the
      // kit cards below, and asking it first keeps both decisions on one screen.
      '<div class="qtyrow">' +
        '<span class="qtyrow__q">' +
          '<span class="qtyrow__label">How many kits?</span>' +
          '<span class="qtyrow__note">One per adult. ' + learnBtn('perAdult', 'Why?') + '</span>' +
        '</span>' +
        '<span class="adults-row">' + btns + '</span>' +
      '</div>' +
      '<p class="stage-note stage-note--which">Both are professionally printed and assembled. ' +
      learnBtn('chooseKit', 'Help me choose') + '</p>' +
      // Nothing after the cards: the ready-made kits are offered in the masthead,
      // above the first question, and the three-or-more-adults line was a footnote
      // for a case almost nobody in this builder is in.
      cards;
  };

  RENDER.names = function () {
    var rows = '';
    for (var i = 0; i < state.adults; i++) {
      var nm = state.names[i] || { full: '' };
      var off = skipped(i);
      rows += '<div class="person' + (off ? ' off' : '') + '">' +
        '<span class="person-head">' +
          '<span class="person-tag">Adult ' + (i + 1) + '</span>' +
          '<label class="plain-check person-skip' + (off ? ' on' : '') + '" data-skip="' + i + '">' +
            '<input type="checkbox"' + (off ? ' checked' : '') + '>' +
            '<span class="pc-box">' + TICK + '</span>' +
            '<span>No personalization</span>' +
          '</label>' +
        '</span>' +
        '<div class="name-grid one">' +
          '<label class="field"><input type="text" data-name="full" data-i="' + i + '" value="' + esc(nameOf(i)) +
            '" placeholder="Full name, exactly as it should be printed" autocomplete="off"' +
            (off ? ' disabled' : '') + '></label>' +
        '</div>' +
      '</div>';
    }

    return '<h2>Let&rsquo;s personalize your CLEAR ' + (state.adults > 1 ? 'Kits' : 'Kit') + '</h2>' +
      '<p class="stage-note">Names are printed on your cover sheets exactly as you enter them.</p>' +
      rows +
      // Show them the exact string that will be printed, immediately above the
      // box asking them to confirm the spelling. Confirming something you cannot
      // see is not a confirmation.
      (anyPersonalized()
        ? '<div class="np">' +
            '<p class="np-note">This is how your personalization will appear on your CLEAR Kit.</p>' +
            '<ul class="np-list">' +
              (function () {
                var out = '';
                for (var p = 0; p < state.adults; p++) {
                  var full = skipped(p) ? '' : nameOf(p);
                  out += '<li class="lp' + (full ? '' : ' empty') + '" data-preview="' + p + '">' +
                    (state.adults > 1 ? '<span class="lp-kit">Kit ' + (p + 1) + '</span>' : '') +
                    '<span class="lp-name">' +
                      (skipped(p) ? 'No personalization' : (full ? esc(full) : 'Your name here')) +
                    '</span></li>';
                }
                return out;
              }()) +
            '</ul>' +
          '</div>'
        : '') +
      // You cannot confirm spelling you have not entered, so the box stays
      // disabled until every adult has a name or has been opted out.
      // A confirmation only counts while the names are actually complete. Without
      // the `&& complete` guard a stale namesConfirmed rendered as a ticked box
      // over half-typed names - it looked confirmed and could not be unticked.
      (anyPersonalized()
        ? (function () {
            var complete = allNamesFilled();
            var ticked = state.namesConfirmed && complete;
            return '<label class="plain-check confirm' + (ticked ? ' on' : '') +
              (complete ? '' : ' na') + '" data-toggle="namesConfirmed">' +
              '<input type="checkbox"' + (ticked ? ' checked' : '') +
              (complete ? '' : ' disabled') + '>' +
              '<span class="pc-box">' + TICK + '</span>' +
              '<span>I have reviewed all names and confirmed the spelling is correct</span>' +
            '</label>';
          }())
        : '');
  };

  RENDER.storage = function () {
    var c = compute();

    // Two Adult Expanded used to have the whole step replaced with a single
    // forced "two Deluxe cases" option. That was wrong: wanting no case, or only
    // a document case, is a legitimate answer for any configuration. The rule is
    // about quantity, not eligibility - if they choose Deluxe, they need two.

    // Confirm the choice actually fits what they are ordering, rather than
    // leaving them to work out whether three binders go in one case.
    // Both cases are one per order now, so there is no quantity to explain for
    // Compact. Only the Large case still needs a capacity check.
    var rec = '';
    if (state.caseType === 'large') {
      var capacity = LARGE_CASE_BINDERS * Math.max(1, c.caseQty);
      if (c.binders <= capacity) {
        rec = '<div class="rec ok"><span class="ok-ic">' + TICK + '</span>' +
          '<span>Your order includes ' + numWord(c.binders) + ' ' +
          (c.binders === 1 ? 'binder, which fits' : 'binders, which all fit') +
          ' inside ' + (c.caseQty > 1 ? numWord(c.caseQty) + ' Large cases' : 'one Large case') +
          '.</span></div>';
      } else {
        rec = '<div class="rec">Your order contains ' + plural(c.binders, 'binder', 'binders') +
          ', and a Large case holds four. Recommended: <strong>' +
          plural(c.recommendedLarge, 'Large case', 'Large cases') + '</strong>.' +
          '<button type="button" class="rec-btn" data-apply-rec="1">Use ' + c.recommendedLarge + '</button></div>';
      }
    } else if (state.caseType === 'small' && c.binders > 0) {
      rec = '<div class="rec">The Compact case is designed for documents only and does not fit ' +
        'CLEAR Kit binders. The Large case holds a full household kit.</div>';
    } else if (state.caseType === 'none' && c.binders > 0) {
      rec = c.binders <= LARGE_CASE_BINDERS
        ? '<div class="rec ok"><span class="ok-ic">' + TICK + '</span>' +
          '<span>Your order includes ' + numWord(c.binders) + ' ' +
          (c.binders === 1 ? 'binder, which fits' : 'binders, all of which fit') +
          ' in one Large case.</span></div>'
        : '<div class="rec">Your order includes ' + numWord(c.binders) + ' binders. A Large case ' +
          'holds four, so this order would need ' + numWord(c.recommendedLarge) + '.</div>';
    }

    // No quantity stepper. The number of cases follows from the binder count and
    // is derived in compute(), so there is nothing here to get wrong.
    var qtyRow = '';

    return '<h2>Choose your storage case</h2>' +
      '<p class="stage-note">Both cases are fire and water resistant and keep your CLEAR Kit ' +
      'and important documents together in one place your family can easily find.</p>' +
      '<div class="cards three">' +
        optCard({
          group: 'caseType', value: 'small', on: state.caseType === 'small',
          image: img('caseSmall'), name: 'Compact',
          // Compact is ONE PER ORDER, which the sub-label under it has always said
          // and which compute() has always charged. The card alone multiplied by
          // adults, so two adults were quoted + $60 and charged + $30.
          price: '+ ' + money(PRICE.caseSmall),
          sub: 'Documents only &middot; one per order, shared by the household',
          desc: 'Holds files and other critical documents. Binders do not fit inside.',
          learn: 'caseSmall'
        }) +
        optCard({
          group: 'caseType', value: 'large', on: state.caseType === 'large',
          image: img('caseLarge'), name: 'Large', badge: 'Most popular',
          // Quote what they will actually pay: a Large case holds four binders,
          // so the quantity follows binder count (compute's caseQty), NOT the
          // number of adults - two Essentials adults share one case.
          price: '+ ' + money(PRICE.caseLarge * Math.max(1, c.recommendedLarge)),
          sub: c.recommendedLarge > 1
            ? money(PRICE.caseLarge) + ' each &middot; your ' + numWord(c.binders) + ' binders need ' + numWord(c.recommendedLarge) + ' cases'
            : (c.binders > 1 ? 'One case holds all ' + numWord(c.binders) + ' of your binders' : ''),
          desc: 'Pouches, accordion folders and a zip closure, plus a lock. Holds a full household kit, up to four CLEAR Kit binders.',
          learn: 'caseLarge'
        }) +
        optCard({
          group: 'caseType', value: 'none', on: state.caseType === 'none',
          name: 'No case', price: '$0',
          // Empty media block so this option's text lines up with the two that
          // carry a photo, instead of starting at the card edge.
          spacer: true,
          // Singular only when the order really is one binder: one adult, Essentials.
          desc: 'Keep your CLEAR Kit ' + (c.binders === 1 ? 'binder' : 'binders') +
                ' on a shelf or in storage you already have. No fire and water resistant ' +
                'case will be included.'
        }) +
      '</div>' + qtyRow + rec;
  };

  // Row copy written for this list. The product descriptions open with award
  // and category lines, which belong on a product page and not on a one-line
  // row. Matched on product title so a description edit cannot undo them.
  var ADDON_BLURB = [
    { match: /kini|safealert/i,
      html: 'Receive a text notification any time your CLEAR Kit is physically moved.' },
    { match: /one more story/i, html: 'Question prompts that spark stories, memories, and conversations worth keeping.' },
    { match: /nothing left unsaid/i, html: 'Question prompts that help uncover important estate, End-of-Life, and personal information before it is needed.' },
    { match: /no loose ends/i,
      html: '<em>The Smart &amp; Slightly Morbid Guide to Estate Planning and End-of-Life Tasks.</em> 2026 Living Now Book Awards Gold Medal Winner.' }
  ];
  function blurbFor(title, fallback) {
    for (var i = 0; i < ADDON_BLURB.length; i++) {
      if (ADDON_BLURB[i].match.test(title || '')) return ADDON_BLURB[i].html;
    }
    return esc(fallback);
  }

  // Row titles, where the catalogue name is not what a customer needs to read.
  var ADDON_TITLE = [
    { match: /usb/i, text: 'Buried in Work Logo USB Drive' }
  ];
  function titleFor(title) {
    for (var i = 0; i < ADDON_TITLE.length; i++) {
      if (ADDON_TITLE[i].match.test(title || '')) return ADDON_TITLE[i].text;
    }
    return shortTitle(title);
  }

  RENDER.addons = function () {
    var keyEntry = {
      key: 'keyKit',
      title: 'Key Storage Kit',
      price: PRICE.keyKit,
      // The product's featured image is a packshot that reads as nothing at
      // thumbnail size. This is the pouch, card and tags, which is recognisable.
      image: 'https://shop.buriedinwork.com/cdn/shop/files/Key_System.png?width=700',
      blurb: 'Gives every spare key a label and a place, so nobody is left guessing what they open.',
      html: 'Gives every spare key a label and a place, so nobody is left guessing what they open.',
      qty: state.keyKit || 0,
      learnKey: 'keyKit'
    };

    var books = BOOKS.map(function (b) {
      // Prefer a whole first sentence. The old 110 character cap chopped almost
      // every blurb into a trailing ellipsis, which read as broken text rather
      // than as a summary.
      var txt = String(b.body || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      var dot = txt.search(/[.!?](\s|$)/);
      var blurb;
      if (dot > -1 && dot <= 190) blurb = txt.slice(0, dot + 1);
      else if (txt.length <= 190) blurb = txt;
      else {
        var cut = txt.slice(0, 190);
        blurb = cut.slice(0, cut.lastIndexOf(' ')) + '\u2026';
      }
      return {
        key: b.id, title: titleFor(b.title), price: b.price, image: b.image,
        blurb: blurb,
        html: blurbFor(b.title, blurb),
        recommended: /kini|safealert/i.test(b.title || ''),
        qty: state.books[b.id] || 0, book: true
      };
    });

    // Order (Adam, 2026-08-27): Kini, Key Storage, No Loose Ends, USB, then the
    // two card decks. addon_handles supplies the books in that order and the
    // Key Storage Kit slots in directly after Kini.
    var extras = books.slice(0, 1).concat([keyEntry], books.slice(1));

    // Everything here is a quantity now, including the Key Storage System - some
    // households want one per property, or one for a parent's house.
    var grid = '<div class="extras">' + extras.map(function (e) {
      var on = e.qty > 0;
      var control = '<span class="qty">' +
            '<button type="button" class="qty-btn" data-book-step="-1" data-book="' + e.key + '" aria-label="Fewer"' + (e.qty <= 0 ? ' disabled' : '') + '>&minus;</button>' +
            '<span class="qty-n">' + e.qty + '</span>' +
            '<button type="button" class="qty-btn" data-book-step="1" data-book="' + e.key + '" aria-label="More">+</button>' +
          '</span>';
      var learn = e.learnKey
        ? '<button type="button" class="learn" data-learn="' + e.learnKey + '">Learn more</button>'
        : '<button type="button" class="learn" data-learn-book="' + e.key + '">Learn more</button>';
      var open = '<div class="xrow' + (on ? ' on' : '') + '" data-book-row="' + e.key + '">';
      var close = '</div>';
      return open +
        (e.image ? '<span class="tmedia"><img src="' + e.image + '" alt="" loading="lazy"></span>' : '') +
        '<span class="tcopy">' +
          // Recommended sits in the right column above the price, not as an
          // eyebrow over the title: that is the empty corner of the row, and it
          // keeps the title line to one line.
          '<span class="xhead"><strong>' + esc(e.title) + '</strong>' +
            '<span class="xright">' +
              (e.recommended ? '<span class="xrec">Recommended</span>' : '') +
              '<span class="xprice">' + money(e.price) + '</span>' +
            '</span></span>' +
          '<p>' + (e.html || esc(e.blurb)) + '</p>' +
          learn +
        '</span>' +
        control + close;
    }).join('') + '</div>';

    return '<h2>Want to add anything else?</h2>' +
      '<p class="stage-note">Choose a few optional extras to make your CLEAR Kit even more ' +
      'useful for you and your family.</p>' +
      grid;
    // The free inclusions used to be repeated here. They now appear once, in the
    // order summary, where they stay visible on every step instead of only this one.
  };

  // The summary panel is already the receipt. Repeating it here gave the customer
  // the same list twice. This is the other half of "review": each decision, and a
  // way to change it without hunting back through the steps.
  RENDER.review = function () {
    var c = compute();
    var books = chosenBooks();

    var names = [];
    for (var i = 0; i < state.adults; i++) { if (!skipped(i) && nameOf(i)) names.push(esc(nameOf(i))); }

    var extras = [];
    if (state.keyKit) extras.push((state.keyKit > 1 ? state.keyKit + ' &times; ' : '') + 'Key Storage System');
    books.forEach(function (b) {
      var q = state.books[b.id];
      extras.push((q > 1 ? q + ' &times; ' : '') + esc(shortTitle(b.title)));
    });

    var caseLabel = effectiveCaseType() === 'none' ? 'No case'
      : c.caseQty + ' &times; ' + (effectiveCaseType() === 'small' ? 'Compact' : 'Large') + ' storage case';

    // Indices derive from STEPS so reordering the flow cannot silently point a
    // Change link at the wrong step.
    var rows = [
      ['# of CLEAR Kits', plural(state.adults, 'kit', 'kits'), stepIndex('package')],
      ['Kit type', isExpanded() ? 'Expanded' : 'Essentials', stepIndex('package')],
      // One name per line. Comma separated, a second name reads as part of the
      // first at a glance, which is the one field nobody should have to squint at.
      ['Personalization', names.length ? names.join('<br>') : 'Not personalized', stepIndex('names')],
      ['Storage', caseLabel, stepIndex('storage')],
      ['Extras', extras.length ? extras.join(', ') : 'None', stepIndex('addons')]
    ];

    // "Kit" or "Kits" follows the order, so the sentence reads correctly for a
    // two kit household as well as a one kit one.
    var kitWordRev = state.adults > 1 ? 'CLEAR Kits' : 'CLEAR Kit';
    return '<h2>Nice ' + kitWordRev + '. Mom would be proud.</h2>' +
      '<p class="stage-note">Make any changes you&rsquo;d like. Nothing is charged until you ' +
      'add your ' + kitWordRev + ' to your cart and complete checkout.</p>' +
      '<div class="rev-list">' +
        rows.map(function (r) {
          return '<div class="rev-item">' +
            '<span class="rev-k">' + r[0] + '</span>' +
            '<span class="rev-v">' + r[1] + '</span>' +
            '<button type="button" class="rev-change" data-jump="' + r[2] + '">Change</button>' +
          '</div>';
        }).join('') +
      '</div>' +
      // The summary panel is hidden on this step, so the total lives here. The
      // customer must never reach Add to Cart without a price in front of them.
      '<div class="rev-total"><span class="k">Total</span>' +
      '<span class="v">' + money(compute().total) + '</span></div>' +
      '<p class="stage-note" style="margin-top:14px">' + esc(CFG.shipNote || '') + '</p>';
  };

  // ---------- summary ----------
  // One heading, not three. The panel title already says what this is, so the
  // group heading and the "CLEAR Kit" line label were saying it twice more.
  function summaryHtml() {
    if (!state.pkgChosen) {
      return '<div class="sum-group">' +
        '<p class="sum-pending">Your CLEAR Kit will update here as you make your choices.</p></div>';
    }
    var out = '<div class="sum-group">' +
      '<div class="sum-line"><span class="label"><strong>' +
      (isExpanded() ? 'Expanded' : 'Essentials') + ' for ' +
      plural(state.adults, 'person', 'people') + '</strong></span>' +
      '<span class="val">' + money(kitTotal()) + '</span></div>' +
      '<ul class="kit-detail">' +
        kitDetail().map(function (d) { return '<li>' + d + '</li>'; }).join('') +
      '</ul></div>';

    // Extras-step add-ons, priced individually. Key Storage belongs here with the
    // books rather than in the kit bullets - it is a separate thing the customer
    // chose, not part of the kit.
    var addOns = [];
    var extrasSettled = decided('addons') || onStep('addons');
    if (extrasSettled && state.keyKit) {
      addOns.push({ label: (state.keyKit > 1 ? state.keyKit + ' &times; ' : '') + 'Key Storage System',
                    amount: keysCost() });
    }
    if (extrasSettled) {
      chosenBooks().forEach(function (b) {
        var q = state.books[b.id];
        addOns.push({ label: (q > 1 ? q + ' &times; ' : '') + esc(shortTitle(b.title)),
                      amount: q * b.price });
      });
    }
    if (addOns.length) {
      out += '<div class="sum-group"><h3>Also in your order</h3>' +
        addOns.map(function (a) {
          return '<div class="sum-line"><span class="label">' + a.label +
            '</span><span class="val">' + money(a.amount) + '</span></div>';
        }).join('') + '</div>';
    }

    // These four come with every kit regardless of what was chosen, so they are
    // stated once, here, rather than on the Extras step as well. The Learn more
    // buttons work because the summary containers delegate [data-learn] the same
    // way the stage does.
    // Titles only. Four one-line descriptions cost more height in the panel than
    // they earned - one combined popup explains all four for anyone who wants it.
    out += '<div class="sum-group"><h3>In every kit, at no cost</h3>' +
      '<ul class="sum-incl">' +
        (state.ht
          ? '<li><strong>One free year of limited access to Heirloom &amp; Tell' +
            (state.adults > 1 ? ', for each adult' : '') + '</strong></li>'
          : '') +
        '<li><strong>CLEAR Kit Worksheet Library access</strong></li>' +
        '<li><strong>Estate &amp; End-of-Life Summary Workbook</strong></li>' +
        '<li><strong>Getting Started Packet</strong></li>' +
        '<li><strong>Three Notification Cards</strong></li>' +
      '</ul>' +
      '<p class="sum-incl-more">' + learnBtn('included', 'What are these?') + '</p></div>';

    return out;
  }

  // ---------- validation ----------
  function stepError() {
    if (STEPS[state.step].id === 'names' && anyPersonalized()) {
      if (!allNamesFilled()) {
        return 'Enter a first and last name for each adult, or indicate you prefer not to personalize the ' + kitWord() + '.';
      }
      if (!state.namesConfirmed) return 'Please confirm the spelling of the names. They are printed exactly as entered.';
    }
    return null;
  }

  // ---------- render ----------
  // Gated on maxStep, the furthest step reached - NOT state.step. Gating on the
  // current step meant going back to step 1 disabled every step after it, so a
  // customer who checked one earlier answer had to click Next seven times to
  // return, and Review was unreachable.
  function renderProgress() {
    var furthest = Math.max(state.maxStep || 0, state.step);
    $('prog-list').innerHTML = STEPS.map(function (s, i) {
      var passed = i < furthest;
      var cls = i === state.step ? 'now' : (passed ? 'done' : '');
      var inner = passed && i !== state.step ? TICK : String(i + 1);
      // The label rides in its own span so phones can show numbers only (with
      // the current step's name) instead of a row that scrolls off the screen.
      return '<li><button type="button" class="prog-btn ' + cls + '" data-goto="' + i + '"' +
        (i > furthest ? ' disabled' : '') + '>' +
        '<span class="prog-num">' + inner + '</span><span class="prog-lbl">' + s.label + '</span></button></li>';
    }).join('');
    $('prog-fill').style.width = Math.round(((state.step) / (STEPS.length - 1)) * 100) + '%';
  }

  function render() {
    syncNames();
    renderProgress();

    var id = STEPS[state.step].id;
    $('stage').innerHTML = RENDER[id]();

    // The intro line sells the idea of starting. Once they have started it is just
    // height above the question, so it only shows on the first step. The title
    // goes with it: by step 2 the step heading says where you are, and "Build
    // Your Own CLEAR Kit" is only costing the first question its place on screen.
    var intro = document.querySelector('.byo .masthead > p');
    if (intro) intro.hidden = state.step > 0;
    var masthead = document.querySelector('.byo .masthead');
    if (masthead) masthead.hidden = state.step > 0;

    // Review restates every choice, so the summary panel beside it would be the
    // same information twice. Hide it there and let the step run full width.
    var onReview = id === 'review';
    var grid = document.querySelector('.byo .grid');
    var summaryCol = document.querySelector('.byo .summary-col');
    if (grid) grid.classList.toggle('solo', onReview);
    if (summaryCol) summaryCol.hidden = onReview;
    var mob = $('mobile-bar');
    if (mob) mob.hidden = onReview;

    var last = state.step === STEPS.length - 1;
    $('btn-next').innerHTML = last ? 'Add to cart' : 'Next ' + ARROW;
    $('btn-next').classList.toggle('go', last);
    $('btn-back').hidden = state.step === 0;

    var c = compute();
    var meta = metaText();
    $('summary-meta').textContent = meta;
    $('mb-meta').textContent = meta;
    $('summary-body').innerHTML = summaryHtml();
    $('mb-panel').innerHTML = summaryHtml();
    $('total').textContent = state.pkgChosen ? money(c.total) : '\u2014';
    $('mb-total').textContent = state.pkgChosen ? money(c.total) : '\u2014';
    $('ship-note').textContent = CFG.shipNote || '';

    save();
  }

  function refreshTotals() {
    var c = compute();
    var meta = metaText();
    $('summary-meta').textContent = meta;
    $('mb-meta').textContent = meta;
    $('summary-body').innerHTML = summaryHtml();
    $('mb-panel').innerHTML = summaryHtml();
    $('total').textContent = state.pkgChosen ? money(c.total) : '\u2014';
    $('mb-total').textContent = state.pkgChosen ? money(c.total) : '\u2014';
    save();
  }

  // Keeps the storage advice honest after an in-place quantity change.
  // Re-renders the whole step so the fit message, the quantity row and the
  // recommendation cannot disagree after an in-place quantity change.
  function refreshRecommendation() {
    if (STEPS[state.step].id === 'storage') { render(); return; }
    var box = $('stage').querySelector('.rec');
    if (!box) return;
    var c = compute();
    if (state.caseType === 'large' && c.recommendedLarge > state.caseQty) {
      box.innerHTML = 'Your order contains ' + plural(c.binders, 'binder', 'binders') +
        '. Recommended: <strong>' + plural(c.recommendedLarge, 'Large Case', 'Large Cases') + '</strong>.' +
        '<button type="button" class="rec-btn" data-apply-rec="1">Use ' + c.recommendedLarge + '</button>';
      box.hidden = false;
    } else {
      box.hidden = true;
    }
  }

  function clearError() { var e = $('stage-err'); if (e) e.remove(); }
  function showError(msg) {
    clearError();
    var d = document.createElement('div');
    d.className = 'err';
    d.id = 'stage-err';
    d.setAttribute('role', 'alert');
    d.textContent = msg;
    $('stage').appendChild(d);
    d.scrollIntoView({ block: 'nearest' });
  }

  // Changing steps used to call stage.scrollIntoView({block:'start'}), which
  // pinned the STAGE to the top of the window - pushing the progress rail off
  // screen every single time you pressed Next. The customer lost the one thing
  // that tells them where they are, on every step.
  //
  // Scroll to the top of the builder instead, and only when it is not already
  // there. A step that fits in view should not move the page at all.
  // The spine header is sticky and about 76px tall, so scrolling the rail to the
  // top of the WINDOW parks it underneath the header - which is what was cutting
  // the top of each step off. Offset by whatever the header actually measures,
  // and always scroll on a step change rather than only when something is out of
  // view: a shorter step left the page parked where the taller one ended.
  function headerOffset() {
    var bar = document.querySelector('.biwspine[data-part="bar"]');
    if (!bar) return 0;
    // Measure whenever the header is STICKY, not only when it happens to be
    // pinned right now. The scroll target is computed before the page moves, so
    // at that moment the header is usually still in flow and a "is it pinned?"
    // test returns false - which is how the rail ended up scrolled to 12px,
    // underneath a 76px header, with the steps invisible on every advance.
    var wrap = bar.parentElement;
    var pos = wrap ? window.getComputedStyle(wrap).position : '';
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.round(bar.getBoundingClientRect().height) || 0;
  }

  function revealBuilder() {
    var top = document.querySelector('.byo .prog') || $('stage');
    if (!top) return;
    var gap = headerOffset() + 12;
    var r = top.getBoundingClientRect();
    if (Math.abs(r.top - gap) < 6) return;          // already where it should be
    var y = Math.max(0, window.scrollY + r.top - gap);
    try { window.scrollTo({ top: y, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
  }


  // ---------- events ----------
  // The order summary now carries Learn more buttons of its own, and it lives
  // outside #stage, so it needs the same delegation. Both copies of the summary
  // - desktop column and mobile panel - get it.
  ['summary-body', 'mb-panel'].forEach(function (id) {
    var el = $(id);
    if (!el) return;
    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var learn = t.closest('[data-learn]');
      if (!learn) return;
      e.preventDefault(); e.stopPropagation();
      openLearn(learn.getAttribute('data-learn'));
    });
  });

  $('stage').addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var learn = t.closest('[data-learn]');
    if (learn) { e.preventDefault(); e.stopPropagation(); openLearn(learn.getAttribute('data-learn')); return; }

    // "Change" on the review step jumps back to the step that owns that answer,
    // and resets forward progress to it. Changing an upstream answer can
    // invalidate what follows - Expanded forces printing and cases, two adults
    // changes case count - so the customer walks the remaining steps again
    // rather than returning to a Review built on stale downstream choices.
    var jump = t.closest('[data-jump]');
    if (jump) {
      e.preventDefault(); e.stopPropagation();
      state.step = Math.max(0, Math.min(STEPS.length - 1, +jump.getAttribute('data-jump')));
      state.maxStep = state.step;
      render();
      // measure after layout: step 6 collapses the summary card, so a
      // same-frame measurement scrolled past the top of the review panel.
      requestAnimationFrame(revealBuilder);
      return;
    }

    var lb = t.closest('[data-learn-book]');
    if (lb) {
      e.preventDefault(); e.stopPropagation();
      var b = BOOKS.filter(function (x) { return String(x.id) === lb.getAttribute('data-learn-book'); })[0];
      if (b) showDetail(b.title, b.body, b.image, b.price);
      return;
    }

    var ad = t.closest('[data-adults]');
    if (ad) {
      state.adults = Math.min(MAX_ADULTS, Math.max(1, +ad.getAttribute('data-adults') || 1));
      syncNames(); state.namesConfirmed = false; render(); return;
    }

    var as = t.closest('[data-adults-step]');
    if (as) {
      state.adults = Math.min(MAX_ADULTS, Math.max(1, state.adults + (+as.getAttribute('data-adults-step'))));
      syncNames(); state.namesConfirmed = false; render(); return;
    }

    // Quantity steppers update in place. A full re-render detaches the button the
    // user just pressed, so a second rapid tap lands on a node no longer in the DOM.
    var cs = t.closest('[data-case-step]');
    if (cs) {
      state.caseQty = Math.max(1, state.caseQty + (+cs.getAttribute('data-case-step')));
      var caseWrap = cs.parentNode;
      caseWrap.querySelector('.qty-n').textContent = state.caseQty;
      caseWrap.querySelector('[data-case-step="-1"]').disabled = state.caseQty <= 1;
      refreshTotals();
      refreshRecommendation();
      return;
    }

    var rec = t.closest('[data-apply-rec]');
    if (rec) { state.caseQty = compute().recommendedLarge; render(); return; }

    var bs = t.closest('[data-book-step]');
    if (bs) {
      var id = bs.getAttribute('data-book');
      var isKeys = id === 'keyKit';
      var cur = isKeys ? (state.keyKit || 0) : (state.books[id] || 0);
      var next = Math.max(0, Math.min(20, cur + (+bs.getAttribute('data-book-step'))));
      if (isKeys) state.keyKit = next;
      else if (next) state.books[id] = next; else delete state.books[id];

      var row = bs.closest('[data-book-row]');
      row.querySelector('.qty-n').textContent = next;
      row.querySelector('[data-book-step="-1"]').disabled = next <= 0;
      row.classList.toggle('on', next > 0);
      refreshTotals();
      return;
    }

    var sk = t.closest('[data-skip]');
    if (sk) {
      var si = +sk.getAttribute('data-skip');
      state.names[si] = state.names[si] || { full: '' };
      state.names[si].skip = !state.names[si].skip;
      state.namesConfirmed = false;
      clearError();
      render();
      return;
    }

    var tog = t.closest('[data-toggle]');
    if (tog) {
      var key = tog.getAttribute('data-toggle');
      // Clicking the LABEL fires this handler even when the input inside it is
      // disabled, so the disabled state has to be enforced here too. Without
      // this you could confirm spelling for names you had not finished typing.
      if (key === 'namesConfirmed' && !allNamesFilled()) return;
      state[key] = !state[key];
      clearError();
      render();
      return;
    }
  });

  $('stage').addEventListener('change', function (e) {
    var set = e.target.getAttribute && e.target.getAttribute('data-set');
    if (!set) return;
    var v = e.target.value;
    if (set === 'ht') state.ht = v === 'yes';
    else if (set === 'pkg') { state.pkg = v; state.pkgChosen = true; }
    else if (set === 'caseType') { state.caseType = v; if (v !== 'none' && state.caseQty < 1) state.caseQty = 1; }
    render();
  });

  // Names update in place so the field keeps focus while typing.
  $('stage').addEventListener('input', function (e) {
    var which = e.target.getAttribute && e.target.getAttribute('data-name');
    if (!which) return;
    var i = +e.target.getAttribute('data-i');
    state.names[i] = state.names[i] || { full: '' };
    state.names[i][which] = e.target.value;
    state.namesConfirmed = false;

    var prev = $('stage').querySelector('[data-preview="' + i + '"]');
    if (prev) {
      var full = nameOf(i);
      prev.classList.toggle('empty', !full);
      prev.querySelector('.lp-name').textContent = full || 'Your name here';
    }
    var confirmRow = $('stage').querySelector('[data-toggle="namesConfirmed"]');
    if (confirmRow) {
      confirmRow.classList.remove('on');
      // Re-enable the moment every name is complete, and lock it again if a
      // field is cleared. Updated in place so typing never loses focus.
      var complete = allNamesFilled();
      confirmRow.classList.toggle('na', !complete);
      var cb = confirmRow.querySelector('input');
      if (cb) { cb.checked = false; cb.disabled = !complete; }
    }
    refreshTotals();
  });

  $('btn-next').addEventListener('click', function () {
    var err = stepError();
    if (err) return showError(err);
    clearError();
    if (STEPS[state.step].id === 'package') state.pkgChosen = true;
    if (state.step < STEPS.length - 1) {
      state.step++;
      if (state.step > state.maxStep) state.maxStep = state.step;
      render();
      // measure after layout: step 6 collapses the summary card, so a
      // same-frame measurement scrolled past the top of the review panel.
      requestAnimationFrame(revealBuilder);
    } else {
      submit();
    }
  });

  $('btn-back').addEventListener('click', function () {
    if (state.step === 0) return;
    state.step--; clearError(); render();
  });

  $('prog-list').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-goto]');
    if (!b || b.disabled) return;
    state.step = +b.getAttribute('data-goto');
    clearError(); render();
  });

  // The reset button was removed from the markup; keep the handler optional so a
  // missing element cannot throw and take the whole builder down with it.
  var resetBtn = $('btn-reset');
  if (resetBtn) resetBtn.addEventListener('click', function () {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    state.step = 0; state.adults = 1; state.pkg = 'expanded';
    state.names = [{ full: '' }];
    state.namesConfirmed = false; state.ht = true; state.pkgChosen = false; state.maxStep = 0;
    state.caseType = 'large'; state.caseQty = 1; state.keyKit = 0; state.books = {};
    render();
  });

  $('mb-toggle').addEventListener('click', function () {
    var open = $('mb-toggle').getAttribute('aria-expanded') === 'true';
    $('mb-toggle').setAttribute('aria-expanded', open ? 'false' : 'true');
    $('mb-panel').hidden = open;
  });

  $('detail-close').addEventListener('click', function () { $('detail').classList.remove('open'); });
  $('detail').addEventListener('click', function (e) { if (e.target === $('detail')) $('detail').classList.remove('open'); });
  $('payload-close').addEventListener('click', function () { $('payload').classList.remove('open'); });
  $('payload').addEventListener('click', function (e) { if (e.target === $('payload')) $('payload').classList.remove('open'); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $('detail').classList.remove('open');
    $('payload').classList.remove('open');
  });

  // ---------- submit ----------
  function showPayload() {
    $('payload-body').innerHTML = lineItems().map(function (li) {
      var amount = li.each === 0 ? '<span style="color:#253551;font-weight:700">Included</span>' : money(li.each * li.qty);
      return '<tr><td>' + esc(li.name) + '</td><td>' + li.qty + '</td><td>' + amount + '</td></tr>';
    }).join('') +
    '<tr><td><strong>Total</strong></td><td></td><td><strong>' + money(compute().total) + '</strong></td></tr>';
    $('payload').classList.add('open');
    var pcard = $('payload').querySelector('.payload-card');
    if (pcard) pcard.scrollTop = 0;
    $('payload').scrollTop = 0;
    $('payload-close').focus({ preventScroll: true });
  }

  // Adding a build replaces the one THIS page session added, and nothing else.
  //
  // It used to remove every builder line in the cart, matched by the _biw_
  // properties and by the bundle product title. That cannot tell "I went back to
  // change my kit" from "I want a second kit", so personalizing a kit, adding it,
  // then building another wiped the first one - the customer ended up with only
  // the unpersonalized kit (tester report, 2026-08-27).
  //
  // Matching by build id is not available: the cart transform merges the
  // component lines into the bundle product and drops every _biw_ property in
  // the process, leaving only the visible attributes it emits. So we track the
  // line keys our own add created instead, by diffing the cart around it.
  //
  // ownedKeys is deliberately NOT persisted. A fresh page load means the
  // customer came back to build ANOTHER kit, and their first one must survive.
  var ownedKeys = [];

  function cartKeys() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        return (cart.items || []).map(function (it) { return it.key; });
      });
  }

  function removeOwnedLines() {
    if (!ownedKeys.length) return Promise.resolve();
    // One line per pass, re-reading the cart each time: a mutation can reissue
    // the remaining lines' keys, and the transform may regroup them, so keys
    // captured in a single snapshot go stale after the first removal. A key we
    // can no longer find is skipped rather than treated as an error - leaving a
    // duplicate the customer can see and remove is far better than blocking the
    // add or deleting a line we cannot positively identify.
    function pass(remaining) {
      if (remaining <= 0) return Promise.resolve();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (it) {
            return ownedKeys.indexOf(it.key) !== -1;
          })[0];
          if (!line) return;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (res) {
            if (!res.ok) throw new Error('cart change failed: ' + res.status);
            var i = ownedKeys.indexOf(line.key);
            if (i !== -1) ownedKeys.splice(i, 1);
            return pass(remaining - 1);
          });
        });
    }
    return pass(40);
  }

  var FAILED_ADD = 'We could not add this to your cart. Please try again.';
  // Recovery, successful retry and final failure go to GA4 as cart_add_issue so
  // the 504 rate can be watched.
  function trackAddIssue(outcome, detail) {
    try {
      var params = { outcome: outcome, add_path: 'byo_builder', detail: String(detail || '').slice(0, 80), page_path: location.pathname };
      if (typeof window.gtag === 'function') window.gtag('event', 'cart_add_issue', params);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: 'cart_add_issue' }, params));
    } catch (e) {}
  }

  function submit() {
    if (!CFG.liveCart) return showPayload();
    var items = cartItems();
    if (!items.length) return showError('This kit has nothing in it yet.');

    var before = [];
    function postBuild() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        var isJson = /json/.test(r.headers.get('content-type') || '');
        if (r.ok) return r.json();
        if (isJson && r.status < 500) {
          return r.json().then(function (e) {
            var err = new Error(e.description || e.message || FAILED_ADD);
            err.rejected = true;
            throw err;
          });
        }
        throw new Error('cart/add returned ' + r.status);
      });
    }
    removeOwnedLines()
      // A failed removal must not block the sale. The worst case is a duplicate
      // sitting in the cart where the customer can see and remove it; refusing
      // to add loses the order outright.
      .catch(function () {})
      .then(cartKeys)
      .then(function (keys) { before = keys; })
      .then(function () {
        return postBuild().catch(function (err) {
          // A network error, a 5xx or a non-JSON body: the add may or may not
          // have landed. Anything in the cart that was not there a moment ago
          // is this build, so look before retrying once, and never add twice.
          if (err && err.rejected) throw err;
          return cartKeys().then(function (after) {
            var landed = after.some(function (k) { return before.indexOf(k) === -1; });
            if (landed) { trackAddIssue('recovered', err && err.message); return null; }
            return new Promise(function (r) { setTimeout(r, 1000); })
              .then(postBuild)
              .then(function (res) { trackAddIssue('retried_ok', err && err.message); return res; });
          });
        });
      })
      .then(function () {
        // Whatever is in the cart now that was not there a moment ago is this
        // build - including the single line the transform merged it into.
        return cartKeys().then(function (after) {
          ownedKeys = after.filter(function (k) { return before.indexOf(k) === -1; });
        }).catch(function () {});
      })
      .then(function () {
        try { localStorage.removeItem(STORE_KEY); } catch (e) {}
        window.location.href = '/cart';
      })
      .catch(function (err) {
        if (!(err && err.rejected)) trackAddIssue('failed', err && err.message);
        showError(err && err.rejected && err.message ? err.message : FAILED_ADD);
      });
  }

  restore();
  render();

  // Exposed for the test harness only.
  window.__byo = { state: state, compute: compute, cartItems: cartItems, lineItems: lineItems, STEPS: STEPS };
})();
